import cn from './cn.js';

const tones = {
  brand: 'bg-indigo-600',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  danger: 'bg-red-500',
};

/** Horizontal progress bar. `value` 0..100. */
export default function Progress({ value = 0, tone = 'brand', size = 'md', className, label, showValue = false, indeterminate = false }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className={cn('w-full', className)}>
      {(label || showValue) && (
        <div className="mb-1.5 flex items-center justify-between text-xs">
          <span className="font-medium text-gray-700">{label}</span>
          {showValue && <span className="tabular-nums text-gray-500">{Math.round(pct)}%</span>}
        </div>
      )}
      <div
        className={cn('w-full overflow-hidden rounded-full bg-gray-100', size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-3' : 'h-2')}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={indeterminate ? undefined : Math.round(pct)}
      >
        <div
          className={cn('h-full rounded-full transition-[width] duration-300 ease-out', tones[tone] || tones.brand, indeterminate && 'w-1/3 animate-pulse')}
          style={indeterminate ? undefined : { width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
